import { C } from "../../constants/theme";
import { toast } from "../../hooks/useToast";

/* Botão "Colar" dos campos de link do MakerWorld.

   No desktop o Ctrl+V já funciona em qualquer lugar do modal (useColarLink),
   mas no Android não existe Ctrl+V — sem este botão o usuário precisa segurar
   o dedo no campo e achar "Colar" no menu do sistema. Estilo neutro de
   propósito: o mesmo botão aparece dentro dos dois sistemas de formulário.

   `colar` é a função devolvida por useColarLink. */
export function BotaoColarLink({ colar, desabilitado, style }) {
  const clicar = async () => {
    if (await colar()) return;
    toast("Não achei um link copiado. Copie o endereço do modelo no MakerWorld e tente de novo.", "warning");
  };
  return (
    <button type="button" onClick={clicar} disabled={desabilitado}
      title="Colar o link que você copiou" aria-label="Colar link"
      style={{ flexShrink:0, background:"transparent", border:"1px solid " + C.border, color:C.muted,
        borderRadius:8, padding:"0 12px", fontSize:12.5, fontWeight:700, whiteSpace:"nowrap",
        cursor:desabilitado ? "default" : "pointer", opacity:desabilitado ? .5 : 1, ...style }}>
      📋 Colar
    </button>
  );
}
